/**
 * CreditHistory.js — MIGRATED to React Query + apiClient pattern
 *
 * Before: raw axios + useState(loading/history) + useEffect (fetchHistory) + separate UserList fetch
 * After:  useBalanceHistory() — one hook, data/loading/error handled automatically
 */
import React, { useEffect } from 'react'
import { Card, Table, Row, Col, Form, Button } from 'antd';
import { CloudDownloadOutlined } from '@ant-design/icons';
import Flex from 'components/shared-components/Flex';
import { useMyContext } from 'Context/MyContextProvider';
import { useBalanceHistory } from 'hooks/api/useUsers';

const CreditHistory = () => {
    const { UserData, HandleExport, Permisson, navigate } = useMyContext();

    useEffect(() => {
        if (!Permisson?.includes('View Payment History')) {
            navigate('404')
        }
    }, [Permisson, navigate]);

    const { data: history = [], isLoading: loading } = useBalanceHistory(UserData?.id);

    const tableColumns = [
        {
            title: 'Company Name',
            dataIndex: 'name',
            render: (_, record) => record?.user?.company_name,
            sorter: {
                compare: (a, b) => (a?.user?.company_name?.length || 0) - (b?.user?.company_name?.length || 0),
            },
        },
        {
            title: 'Account Manager',
            dataIndex: null,
            render: (_, record) => record?.account_manager?.company_name,
            sorter: {
                compare: (a, b) => (a?.account_manager?.company_name?.length || 0) - (b?.account_manager?.company_name?.length || 0),
            },
        },
        {
            title: 'Credit',
            dataIndex: 'new_credit',
            sorter: {
                compare: (a, b) => a.new_credit - b.new_credit,
            },
        },
        {
            title: 'Transaction Type',
            dataIndex: 'type',
            render: (_, record) => record?.manual_deduction !== null ? 'Debit' : 'Credit',
        },
        {
            title: 'Date',
            dataIndex: 'created_at',
            render: (created_at) => {
                const date = new Date(created_at);
                const day = ("0" + date.getDate()).slice(-2);
                const month = ("0" + (date.getMonth() + 1)).slice(-2);
                const year = date.getFullYear();
                let hours = date.getHours();
                const minutes = ("0" + date.getMinutes()).slice(-2);
                const seconds = ("0" + date.getSeconds()).slice(-2);
                let ampm = hours >= 12 ? 'PM' : 'AM';
                hours = hours % 12;
                hours = hours ? hours : 12;
                const formattedTime = `${hours}:${minutes}:${seconds} ${ampm}`;
                return `${day}/${month}/${year} | ${formattedTime}`;
            },
        },
    ];

    return (
        <Card bodyStyle={{ padding: '0px' }}>
            <div className="container-fluid">
                <Flex justifyContent="space-between" alignItems="center" className="py-4">
                    <h2>Credit History</h2>
                    <Button
                        icon={<CloudDownloadOutlined />}
                        onClick={() => HandleExport('export-credit-history', 'crdit_history.xlsx')}
                    >
                        Export Credit History
                    </Button>
                </Flex>
            </div>
            <div className="table-responsive">
                <Table
                    loading={loading}
                    columns={tableColumns}
                    dataSource={history}
                    rowKey="id"
                />
            </div>
        </Card>
    );
};

export default CreditHistory
